import { render } from "./ReviewItem.vue?vue&type=template&id=36d3dbde"
import script from "./ReviewItem.vue?vue&type=script&lang=js"
export * from "./ReviewItem.vue?vue&type=script&lang=js"

import "./ReviewItem.vue?vue&type=style&index=0&id=36d3dbde&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__